module.exports = __webpack_public_path__ + "static/media/civil.465d3e0a.svg";